module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), (_vm.loadingRedirection) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isSuccessModalVisible) ? _c('success') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [(_vm.loginStep === 'login' && !_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center login-intro-desktop"
  }, [_vm._v("\n          Log in to your account below |\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Registration'
      }
    }
  }, [_vm._v("First time user?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-intro-mobile"
  }, [_c('p', {
    staticClass: "text-center login-intro-main"
  }, [_vm._v("Log in to your account below")]), _vm._v(" "), _c('p', {
    staticClass: "text-center login-intro-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Registration'
      }
    }
  }, [_vm._v("First time user?")])], 1)]), _vm._v(" "), (_vm.migrationNeeded) ? _c('div', {
    staticClass: "alert alert-info text-center"
  }, [_vm._v("\n          We've updated our system. Please\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v("Reset Password")]), _vm._v("\n          to access your account.\n        ")], 1) : _vm._e(), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), (_vm.isUserIdle) ? _c('p', [_c('strong', {
    staticClass: "text-red"
  }, [_vm._v("You have been logged out of your account due to\n            inactivity.")])]) : _vm._e(), _vm._v(" "), (_vm.fromPasswordResetEmail) ? _c('p', [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Your password has been reset\n            successfully.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleLoginSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedEmail),
      expression: "computedEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.computedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock4"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "remember-forgot-container"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox mt0"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "rememberMe"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, "") > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "name": "check"
    }
  })], 1), _vm._v("Remember Me")])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-link"
  }, [_c('router-link', {
    staticClass: "text-muted",
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v("Forgot your password?")])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm || _vm.loadingMfaOptions
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loadingMfaOptions ? 'Loading...' : 'Log in') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.loginError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.loginError))])])])]) : _vm._e(), _vm._v(" "), (_vm.loginStep === 'method') ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleMethodSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "method-selector mb-lg"
  }, [(_vm.mfaOptions && _vm.mfaOptions.emailAvailable) ? _c('label', {
    staticClass: "method-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMethod),
      expression: "selectedMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "method",
      "value": "EMAIL"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedMethod, "EMAIL")
    },
    on: {
      "__c": function($event) {
        _vm.selectedMethod = "EMAIL"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "method-text"
  }, [_c('strong', [_vm._v("Email")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Send code to " + _vm._s(_vm.mfaOptions.email))])])]) : _vm._e(), _vm._v(" "), (_vm.mfaOptions && _vm.mfaOptions.smsAvailable) ? _c('label', {
    staticClass: "method-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMethod),
      expression: "selectedMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "method",
      "value": "SMS"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedMethod, "SMS")
    },
    on: {
      "__c": function($event) {
        _vm.selectedMethod = "SMS"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "method-text"
  }, [_c('strong', [_vm._v("Text Message")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Send code to " + _vm._s(_vm.mfaOptions.mfaPhonePreference === 'SECONDARY' ? _vm.mfaOptions.secondaryPhone : _vm.mfaOptions.phone))])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submittedForm ? 'Sending...' : 'Send Code') + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-lg"
  }, [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("Back")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginStep === 'code' && _vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n          Code sent to "), _c('strong', [_vm._v(_vm._s(_vm.sentTo))]), _vm._v(" via " + _vm._s(_vm.selectedMethod === 'SMS' ? 'text message' : 'email') + "\n        ")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmCognitoMfaCode()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaCode),
      expression: "mfaCode"
    }],
    staticClass: "form-control code-input",
    attrs: {
      "id": "mfaCode",
      "type": "text",
      "placeholder": "Enter code",
      "autocomplete": "off",
      "required": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.mfaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mfaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedMfa || _vm.mfaCode.length !== 6
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submittedMfa ? 'Verifying...' : 'Verify') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "resend-options"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Didn't receive the code?")]), _vm._v(" "), (_vm.selectedMethod === 'EMAIL' && _vm.mfaOptions && _vm.mfaOptions.smsAvailable) ? _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendWithDifferentMethod('SMS')
      }
    }
  }, [_vm._v("\n            Send via text message instead\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedMethod === 'SMS' && _vm.mfaOptions && _vm.mfaOptions.emailAvailable) ? _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendWithDifferentMethod('EMAIL')
      }
    }
  }, [_vm._v("\n            Send via email instead\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendCurrentMethod()
      }
    }
  }, [_vm._v("\n            Resend code\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-lg"
  }, [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToMethodSelection
    }
  }, [_vm._v("Back")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Choose verification method")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Enter verification code")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-005fb977","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2097
// module chunks = 1